import { useCallback } from 'react';
import { Link, useLocation, type LinkProps } from 'react-router-dom';
import GaTracker from '../../utils/GaTracker/GaTracker';

const RouterLink = (props: LinkProps) => {
  const location = useLocation();

  const onClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      GaTracker.trackEvent({
        category: 'Link',
        action: `navigate-from${
          location.pathname === '/' ? '-home' : location.pathname.replace('/', '-')
        }-to${(props.to as string).replace('/', '-')}`,
        label: props.to as string,
      });

      props.onClick?.(e);
    },
    [props, location.pathname],
  );

  return <Link {...props} onClick={onClick} />;
};

export default RouterLink;
